import React, { useMemo } from "react";
import Loader from "../../components/Loader";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import {
  convertStringToArray,
  extractDateFromStr,
  getLatestDateFromData,
  getLatestUpdatedObject,
} from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { useTableResponsive } from "../../hooks/useTableResponsive";
import useSeo from "../../hooks/useSeo";
import { useLocation } from "react-router-dom";
import PdfZipItem from "../../components/PdfZipItem";

const TariffPetition = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const { data: tariffPetitionData = [], isLoading: tariffPetitionIsLoading } =
    useGetProtectedApiDataQuery({ url: "tariff_petition", lang: languageType });

  const transformedTariffPetitionData = useMemo(() => {
    return tariffPetitionData?.map((item) => ({
      ...item,
      field_document_equity: convertStringToArray(item.field_document_equity),
    }));
  }, [tariffPetitionData]);

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(tariffPetitionData);
  }, [tariffPetitionData]);

  useTableResponsive(tariffPetitionData);

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  if (tariffPetitionIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Commercial", "वाणिज्यिक")}
        titleLink="/commercial/tariff-petition"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />

            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                {/* <div className="title-sec">
                  <h4>Tariff Petition for NEEPCO</h4>
                </div> */}
                {/* <!--table grid section start here--> */}
                <div className="table-responsive">
                  <table className="table table-striped custom-table">
                    <thead className="thead-dark">
                      <tr>
                        <th>{getText("S.No.", "क्र. सं.")}</th>
                        <th>{getText("Description", "विवरण")}</th>
                        <th>{getText("Download", "डाउनलोड")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transformedTariffPetitionData.map((item, index) => (
                        <tr key={index}>
                          <td data-key={getText("S.No.", "क्र. सं.")}>
                            {index + 1}
                          </td>
                          <td data-key={getText("Description", "विवरण")}>
                            {item.title}
                          </td>
                          <td data-key={getText("Download", "डाउनलोड")}>
                            <div className="tariff-div">
                              {item.field_document_equity.map(
                                (subitem, subindex) => (
                                  <PdfZipItem
                                    key={subindex}
                                    filePath={subitem?.file_path}
                                    title={subitem.title}
                                  />
                                )
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {/* <!--table grid end here--> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TariffPetition;
